import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const ScrollToTop = () => {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    // If there's a hash (anchor link), scroll to that element
    if (hash) {
      const element = document.querySelector(hash);
      if (element) {
        element.scrollIntoView({ behavior: "smooth" });
        return;
      }
    }
    
    // Otherwise, scroll to top
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "instant" // Use instant for page navigation, smooth for in-page
    });
  }, [pathname, hash]);

  return null;
};

export default ScrollToTop;
